const routeTypes = {
    AUTHENTICATED: 'AUTHENTICATED',
    NOT_AUTHENTICATED: 'NOT_AUTHENTICATED',
    PUBLIC: 'PUBLIC',
};

export default routeTypes;
